/* eslint typescript-sort-keys/interface: "error" */
/* eslint sort-keys-fix/sort-keys-fix: "error" */
export type FeatureFlagsSimplifi = {
  a2A: boolean;
  a2AInvestmentAccounts?: boolean;
  accountListSubLevelAdd: boolean;
  accountListVisibilityPreference?: boolean;
  accountsManagement: boolean;
  achievements: any;
  addFiDefaultProvider: any;
  addFiUsePlaidSearch: boolean;
  addGoalSpendingPlan: boolean;
  addfiSecPrivTrust: boolean;
  advancedReportingEnabled: boolean;
  aggErrorHandleDeadAccounts: boolean;
  aiChat: boolean;
  allowAssetLiabilityLoanAccts: boolean;
  allowInvestmentAccountCreate: boolean;
  appTrackingTransparencyPrompt?: boolean;
  autoCategorizeUncategorized: boolean;
  balanceToggle: boolean;
  barchart: boolean;
  barchartAdvanced: boolean;
  billPresentment: boolean;
  billsBillgoShutdown: boolean;
  billsFiserv: boolean;
  billsIncomeActivity: boolean;
  billsViaAggregation?: boolean;
  bizMiles: boolean;
  bizOnboardingEnabled?: boolean;
  browserMinVersion: { Chrome: string; Edge: string; Firefox: string; Safari: string };
  btsCategories?: boolean;
  btsClientName?: string;
  budgets: boolean;
  bumpAccounts: boolean;
  bumpBadges: boolean;
  bumpBusiness: boolean;
  bumpGoals: boolean;
  bumpInstitutionLogins: boolean;
  bumpProcessTxnUpdates: boolean;
  bumpReportConfigurations: boolean;
  bumpSecurities: boolean;
  bumpSpendingPlan: boolean;
  bumpTags: boolean;
  businessCreditMemos: boolean;
  businessDowngrade?: boolean;
  businessEnabled: boolean;
  businessEstimates: boolean;
  businessRefunds: boolean;
  businessSalesReceipts: boolean;
  businessUpgrade?: boolean;
  calculatorList?: any;
  calculators: boolean;
  calendarList?: boolean;
  cashFlow: boolean;
  categorizeUncategorizedFromSpending: boolean;
  categoryIcons: boolean;
  categoryPropogationEnabled: boolean;
  categoryReviewCardWatchlist: boolean;
  categorySelectOnTab: boolean;
  ccpa: boolean;
  checkNumberTxnDetails?: boolean;
  closeAccount: boolean;
  closedBusiness?: boolean;
  cobrowse: boolean;
  configureDashboard: boolean;
  contentSecurityPolicy: string;
  contributeToGoalInUnlimitedPastMonths?: boolean;
  contributeToGoalOneMonthPast?: boolean;
  copyPasteEnabled: boolean;
  creditReport: boolean;
  creditReportHistory?: boolean;
  creditsOnInvoice?: boolean;
  csvImport: boolean;
  customDialogButtons: boolean;
  customFrequency?: boolean;
  customersEnabled: boolean;
  darkMode: boolean;
  dateKeyboardShortcuts?: boolean;
  dateOnAfter?: { value: string | number };
  debug: boolean;
  deleteAndReassignCategoryQcs: boolean;
  deleteInvoice?: boolean;
  deleteProject: boolean;
  demoMode: boolean;
  demoModeWhiteList: string[];
  disableExternalLinks?: any;
  disableTransfers: boolean;
  discoverAccountTooltip: boolean;
  dragDialog: boolean;
  editAccountDetails: boolean;
  editRunningBalance: boolean;
  editableArAccounts?: boolean;
  excludeFromReportsSetting: boolean;
  exposeInvestmentTransactions?: string;
  featureTogglesPage?: boolean;
  feedback: boolean;
  fetchDebounce: number;
  fiCredentialEncryption: any;
  fiStatus?: boolean;
  filterClientProject?: boolean;
  finances: boolean;
  finicityEnv?: any;
  flagBalanceMismatchWithEvent: boolean;
  futureFreeToSpend: boolean;
  futureTxns?: boolean;
  goalWithdrawTxns: boolean;
  goals: boolean;
  goalsCalculator: boolean;
  goalsSpendingPlan: boolean;
  hearAboutSurvey: boolean;
  hideConnectedLoanTransactions: boolean;
  hideInAccountListSetting: boolean;
  hideLoanTransactions: boolean;
  hotjar: boolean;
  ignoreAccount: boolean;
  ignoreRefreshThrottle: boolean;
  importMintBalances?: any;
  inProductNotifications: boolean;
  includeReceiptsWithInvoices?: boolean;
  incomeExpenseReport?: boolean;
  intercom: boolean;
  investmentAccountGoalContributions?: boolean;
  investmentBalanceChart?: boolean;
  investmentBalancesTotalChart?: boolean;
  investmentCard1DayChange?: boolean;
  investmentGains?: boolean;
  investmentPerformance: boolean;
  investmentTransactions: boolean;
  investmentTransactionsReports: boolean;
  investmentsAcme: boolean;
  invoiceTransactions: boolean;
  invoices?: boolean;
  ldHasDatasetId?: boolean;
  ldHasDatasetTier?: boolean;
  limit?: number;
  loggingLevel: any;
  maintenance: any;
  manageAccountsGroupManualByType: boolean;
  manualHoldings: boolean;
  matchAmountVariants?: number;
  maxAttachmentsPerTxn: number;
  maxCategoryDepth: number;
  maxDatasets: number;
  memorizedRuleApplyToExistingQcs: boolean;
  mintImportAsync?: boolean;
  mintImportExtension?: boolean;
  mixpanelProxy: boolean;
  mobileReportDateRange?: boolean;
  mobileReportsBreakdown?: boolean;
  monthlyAnnualAlert: boolean;
  monthlySummary: boolean;
  nativeBackgroundSync: boolean;
  netWorth: boolean;
  newCategorySettingsEnabled: boolean;
  newDatagridRegister?: boolean;
  newNavbar?: boolean;
  noDateOnBankPending: boolean;
  notificationPreferences: boolean;
  notifications: boolean;
  notificationsV2?: boolean;
  nps: number;
  offerReplacementOnDelete: boolean;
  oldRegister: boolean;
  orphanedInstitutionLogins?: boolean;
  payeeAutoFillAmount: boolean;
  payeeAutoFillCat: boolean;
  payeeAutoFillMemo: boolean;
  payeeAutoFillTags: boolean;
  payeeFieldsIncludeAllAccounts: boolean;
  payeeRuleMultiselect?: boolean;
  payeeShowFillInfoInMenu: boolean;
  pendo: any;
  persist: boolean;
  persistPurgeVersion: any;
  plaidEnv?: any;
  plannedSpendingAutoRelease: boolean;
  plannedSpendingRollovers: boolean;
  plannedSpendingSummary: boolean;
  plannedSpendingViewToggle: boolean;
  playBilling: boolean;
  prefAdvancedOption: boolean;
  prefAllowEditingAmounts: boolean;
  prefAutoSaveEditedTransactions: boolean;
  prefAutoSearch: boolean;
  prefColoredAccounts: boolean;
  prefCurrencySymbolTransactionList: boolean;
  prefDeleteDownloaded: boolean;
  prefLongCatName: boolean;
  prefMoneyInOutColumn: boolean;
  prefNewTransactionEntry: boolean;
  prefShowPreferences: boolean;
  prefWrapText: boolean;
  privacyMode?: boolean;
  profileHelpSupport: boolean;
  projectedBalances: boolean;
  qCardsOn: boolean;
  qbpMileageTracker: boolean;
  qbpPrereleaseChip?: boolean;
  qbpUsageTxnrulesv2?: boolean;
  realTimeQuotes: boolean;
  recentTxnAcme: boolean;
  recurringManagement: boolean;
  recurringMatchCriteria?: boolean;
  refreshPollInterval: number;
  refreshPollTimeout: number;
  refundTracker: boolean;
  relyOnSecurities: boolean;
  renameRuleApplyToExistingQcs: boolean;
  reorderAccountBar: boolean;
  reportExportToTax?: boolean;
  reportGridGraph: boolean;
  reportTaxDetailBusiness?: boolean;
  reportTaxDetailPersonal?: boolean;
  reports: boolean;
  reportsBalanceSheet?: boolean;
  reportsClientTxns?: boolean;
  reportsIgnoreExcludedAccounts: boolean;
  reportsMoveRfndtrkrCrdtscr: boolean;
  reportsPrint?: boolean;
  reportsReplaceLegacy?: boolean;
  reportsSplitsList: boolean;
  reportsStickyConfig: boolean;
  reportsTransactionsRegister: boolean;
  reportsV3: string;
  resetDefaultDashboard: boolean;
  retirementPlanner: boolean;
  scheduledTransactions: boolean;
  scheduledTransactionsInRegister: boolean;
  securities: boolean;
  securitiesSettings: any;
  serviceWorkerEnable: boolean;
  serviceWorkerEnableInstall: boolean;
  serviceWorkerEnablePushNotifications: boolean;
  serviceWorkerUpdateInterval: number;
  serviceWorkerUpdateOnIdleTimeout: number;
  serviceWorkerUpdateOnIdleWindow: number;
  serviceWorkerUpdateOnLoad: boolean;
  serviceWorkerUpdateOnNavigation: boolean;
  serviceWorkerUserUpdateTimeout: number;
  serviceWorkerUserUpdateWindow: number;
  setupChecklist: number;
  sharingEnabled: boolean;
  showInvestmentsCard?: boolean;
  showTxnJson: boolean;
  spendingPlan: boolean;
  spendingPlanClientCalc?: boolean;
  spendingPlanCloseout?: boolean;
  spendingPlanPastRolloverControl: boolean;
  spendingPlanRollForward: boolean;
  spendingPlanSetup: any;
  spendingPlanTransfers: boolean;
  spendingPlanV2: boolean;
  spendingWatchList: boolean;
  splitShowNotes: boolean;
  splitSwitchOnLeft: boolean;
  splitsDetailsInDialog: boolean;
  splitsSideBySide: boolean;
  splitsV2?: boolean;
  stockLogo: boolean;
  stripeEnabled?: boolean;
  subscriptionAlerts: boolean;
  subscriptionsV2?: boolean;
  suggestCategoryForUncategorized: boolean;
  survey: boolean;
  tagsAsHashes: boolean;
  taxItemsEnabled: boolean;
  taxPlanner: boolean;
  tickerValidate: string;
  timeTracking?: boolean;
  todoList?: boolean;
  trackLogoTicker: boolean;
  transactionDetailsComprehensive: boolean;
  transactionFilters: boolean;
  transactionsSettings: boolean;
  transactionsSize?: number;
  txnCancelExtraColumn: boolean;
  txnDetailsModal: boolean;
  undo: any;
  upcoming: boolean;
  upcomingRedesign: boolean;
  userGuideEnabled: boolean;
  watchlistSetup: number;
  watchlistTimeSelector: boolean;
  webSocketQcs: number;
  webSocketQcsWatchList: boolean;
  zeroStateOnNoAccounts: boolean;
};

const featureFlagBaseDefaults: FeatureFlagsSimplifi = {
  a2A: false,
  accountListSubLevelAdd: false,
  accountsManagement: true,
  achievements: true,
  addFiDefaultProvider: 'USE_PREFERENCE_SERVICE',
  addFiUsePlaidSearch: false,
  addGoalSpendingPlan: false,
  addfiSecPrivTrust: false,
  advancedReportingEnabled: false,
  aggErrorHandleDeadAccounts: true,
  aiChat: false,
  allowAssetLiabilityLoanAccts: true,
  allowInvestmentAccountCreate: true,
  autoCategorizeUncategorized: true,
  balanceToggle: true,
  barchart: false,
  barchartAdvanced: false,
  billPresentment: true,
  billsBillgoShutdown: false,
  billsFiserv: false,
  billsIncomeActivity: true,
  billsViaAggregation: false,
  bizMiles: false,
  browserMinVersion: { Chrome: '92', Edge: '92', Firefox: '90', Safari: '15.4' },
  budgets: false,
  bumpAccounts: false,
  bumpBadges: false,
  bumpBusiness: false,
  bumpGoals: false,
  bumpInstitutionLogins: false,
  bumpProcessTxnUpdates: false,
  bumpReportConfigurations: false,
  bumpSecurities: false,
  bumpSpendingPlan: false,
  bumpTags: false,
  businessCreditMemos: true,
  businessEnabled: false,
  businessEstimates: false,
  businessRefunds: false,
  businessSalesReceipts: false,
  calculators: false,
  cashFlow: true,
  categorizeUncategorizedFromSpending: false,
  categoryIcons: false,
  categoryPropogationEnabled: true,
  categoryReviewCardWatchlist: true,
  categorySelectOnTab: false,
  ccpa: true,
  checkNumberTxnDetails: false,
  closeAccount: false,
  cobrowse: true,
  configureDashboard: false,
  contentSecurityPolicy: '',
  copyPasteEnabled: false,
  creditReport: false,
  csvImport: true,
  customDialogButtons: true,
  customFrequency: true,
  customersEnabled: false,
  darkMode: false,
  debug: false,
  deleteAndReassignCategoryQcs: false,
  deleteProject: false,
  demoMode: false,
  demoModeWhiteList: [
    '^get:',
    'post:.*/gamification/event',
    'post:.*/transactions/earliest-date-on',
    'post:.*/job-statuses',
    'delete:.*/job-statuses',
    'post:.*/oauth/token',
    'post:.*/reports/generate',
    'post:.*/logos/tickers',
  ],
  disableTransfers: false,
  discoverAccountTooltip: true,
  dragDialog: false,
  editAccountDetails: false,
  editRunningBalance: false,
  editableArAccounts: false,
  excludeFromReportsSetting: false,
  feedback: true,
  fetchDebounce: 3000,
  fiCredentialEncryption: false,
  finances: false,
  flagBalanceMismatchWithEvent: false,
  futureFreeToSpend: false,
  goalWithdrawTxns: false,
  goals: true,
  goalsCalculator: false,
  goalsSpendingPlan: true,
  hearAboutSurvey: false,
  hideConnectedLoanTransactions: true,
  hideInAccountListSetting: false,
  hideLoanTransactions: false,
  hotjar: false,
  ignoreAccount: false,
  ignoreRefreshThrottle: false,
  inProductNotifications: true,
  includeReceiptsWithInvoices: false,
  intercom: false,
  investmentPerformance: false,
  investmentTransactions: true,
  investmentTransactionsReports: false,
  investmentsAcme: true,
  invoiceTransactions: false,
  invoices: false,
  ldHasDatasetId: false,
  ldHasDatasetTier: false,
  loggingLevel: 2,
  maintenance: false,
  manageAccountsGroupManualByType: false,
  manualHoldings: true,
  maxAttachmentsPerTxn: 5,
  maxCategoryDepth: 2,
  maxDatasets: 1,
  memorizedRuleApplyToExistingQcs: false,
  mixpanelProxy: true,
  monthlyAnnualAlert: false,
  monthlySummary: true,
  nativeBackgroundSync: false,
  netWorth: false,
  newCategorySettingsEnabled: false,
  newNavbar: true,
  noDateOnBankPending: true,
  notificationPreferences: true,
  notifications: true,
  nps: 10000,
  offerReplacementOnDelete: true,
  oldRegister: true,
  payeeAutoFillAmount: false,
  payeeAutoFillCat: false,
  payeeAutoFillMemo: false,
  payeeAutoFillTags: false,
  payeeFieldsIncludeAllAccounts: false,
  payeeShowFillInfoInMenu: false,
  pendo: true,
  persist: false,
  persistPurgeVersion: null,
  plannedSpendingAutoRelease: false,
  plannedSpendingRollovers: false,
  plannedSpendingSummary: false,
  plannedSpendingViewToggle: false,
  playBilling: true,
  prefAdvancedOption: false,
  prefAllowEditingAmounts: false,
  prefAutoSaveEditedTransactions: false,
  prefAutoSearch: false,
  prefColoredAccounts: false,
  prefCurrencySymbolTransactionList: false,
  prefDeleteDownloaded: false,
  prefLongCatName: false,
  prefMoneyInOutColumn: false,
  prefNewTransactionEntry: false,
  prefShowPreferences: false,
  prefWrapText: false,
  profileHelpSupport: false,
  projectedBalances: true,
  qCardsOn: false,
  qbpMileageTracker: false,
  realTimeQuotes: true,
  recentTxnAcme: true,
  recurringManagement: false,
  refreshPollInterval: 3000,
  refreshPollTimeout: 300000,
  refundTracker: false,
  relyOnSecurities: false,
  renameRuleApplyToExistingQcs: false,
  reorderAccountBar: false,
  reportGridGraph: false,
  reports: true,
  reportsIgnoreExcludedAccounts: false,
  reportsMoveRfndtrkrCrdtscr: false,
  reportsReplaceLegacy: false,
  reportsSplitsList: false,
  reportsStickyConfig: false,
  reportsTransactionsRegister: true,
  reportsV3: '',
  resetDefaultDashboard: true,
  retirementPlanner: false,
  scheduledTransactions: true,
  scheduledTransactionsInRegister: true,
  securities: false,
  securitiesSettings: false,
  serviceWorkerEnable: true,
  serviceWorkerEnableInstall: false,
  serviceWorkerEnablePushNotifications: false,
  serviceWorkerUpdateInterval: 300000,
  serviceWorkerUpdateOnIdleTimeout: -1,
  serviceWorkerUpdateOnIdleWindow: 600000,
  serviceWorkerUpdateOnLoad: false,
  serviceWorkerUpdateOnNavigation: false,
  serviceWorkerUserUpdateTimeout: 0,
  serviceWorkerUserUpdateWindow: 0,
  setupChecklist: 0,
  sharingEnabled: false,
  showTxnJson: false,
  spendingPlan: true,
  spendingPlanPastRolloverControl: false,
  spendingPlanRollForward: false,
  spendingPlanSetup: '1603177200',
  spendingPlanTransfers: false,
  spendingPlanV2: false,
  spendingWatchList: true,
  splitShowNotes: false,
  splitSwitchOnLeft: false,
  splitsDetailsInDialog: false,
  splitsSideBySide: false,
  stockLogo: false,
  subscriptionAlerts: false,
  suggestCategoryForUncategorized: false,
  survey: false,
  tagsAsHashes: false,
  taxItemsEnabled: false,
  taxPlanner: false,
  tickerValidate: '^[A-Z]{1,5}(\\.[A-Z]{1,3})?$',
  trackLogoTicker: false,
  transactionDetailsComprehensive: false,
  transactionFilters: true,
  transactionsSettings: false,
  txnCancelExtraColumn: true,
  txnDetailsModal: true,
  undo: 10,
  upcoming: true,
  upcomingRedesign: false,
  userGuideEnabled: false,
  watchlistSetup: 1603177200,
  watchlistTimeSelector: false,
  webSocketQcs: 0,
  webSocketQcsWatchList: false,
  zeroStateOnNoAccounts: false,
};

export const featureFlagsSimplifiDefaults: FeatureFlagsSimplifi = {
  ...featureFlagBaseDefaults,
};

export const featureFlagsSimplifiQBPDefaults: FeatureFlagsSimplifi = {
  ...featureFlagBaseDefaults,
  businessEnabled: true,
  customersEnabled: true,
  invoices: true,
  maxCategoryDepth: 3,
  reorderAccountBar: false,
  reportsV3: 'profit-loss, net-income, taxes',
  // taxPlanner: true, enable when tax planner is ready
};
